export const GRID = Object.freeze({
  RECIPE: 'minmax(10%, 30%) 11.5% repeat(3, 7.2%) repeat(2, 11.5%) 1fr',
  DASHOBARD_RECIPE: '1fr 104px 104px',
  MENU_SCHEDULE: '144px 1fr 1fr 1fr',
  ADMINS: 'minmax(10%, 1fr) 1fr 144px 11% 11% 48px',
  SETTINGS: '160px 1fr',
  USERS: 'minmax(10%, 35%) 20% 1fr 1fr 1fr',
});
